export class DatePicker extends HTMLElement {
  static define(tagName = 'date-picker') {
    if ('customElements' in window) {
      customElements.define(tagName, DatePicker);
    }
  }

  /** @returns {?HTMLElement} */
  get sourceElement() {
    return this.#sourceElement;
  }

  /** @param {?HTMLElement} value */
  set sourceElement(value) {
    this.#sourceElement = value;
  }

  /** @returns {?string} */
  get source() {
    return this.getAttribute('source');
  }

  /** @param {?string} value */
  set source(value) {
    if (value) {
      this.setAttribute('source', value);
    } else {
      this.removeAttribute('source');
    }
  }

  /** @returns {?HTMLInputElement} */
  get targetElement() {
    return this.#targetElement;
  }

  /** @param {?HTMLInputElement} value */
  set targetElement(value) {
    this.#targetElement = value;
  }

  /** @returns {?string} */
  get target() {
    return this.getAttribute('target');
  }

  /** @param {?string} value */
  set target(value) {
    if (value) {
      this.setAttribute('target', value);
    } else {
      this.removeAttribute('target');
    }
  }

  /** @type {?HTMLElement} */
  #sourceElement = null;

  /** @type {?HTMLInputElement} */
  #targetElement = null;

  constructor() {
    super();
    this.handleCalendarChange = this.handleCalendarChange.bind(this);
  }

  /**
   * @returns {void}
   */
  connectedCallback() {
    this.#sourceElement = /** @type {?HTMLElement} */ (document.getElementById(this.source));
    this.#targetElement = /** @type {?HTMLInputElement} */ (document.getElementById(this.target));

    this.#sourceElement?.addEventListener('change', this.handleCalendarChange);
  }

  /**
   * @returns {void}
   */
  disconnectedCallback() {
    this.#sourceElement?.removeEventListener('change', this.handleCalendarChange);

    this.#targetElement = null;
    this.#sourceElement = null;
  }

  /**
   * @param {string} value
   */
  selectDate(value) {
    if (! this.#targetElement) {
      return;
    }

    this.#targetElement.value = value;

    this.#targetElement.dispatchEvent(new Event('input', { bubbles: true }));
    this.#targetElement.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * @returns {void}
   */
  showCalendar() {
    const popover = /** @type {?HTMLElement} */ (
      this.#sourceElement?.closest('[popover]')
    );

    popover?.showPopover();
  }

  /**
   * @returns {void}
   */
  hideCalendar() {
    const popover = /** @type {?HTMLElement} */ (
      this.#sourceElement?.closest('[popover]')
    );

    popover?.hidePopover();
  }

  /**
   * @param {Event} event
   */
  handleCalendarChange(event) {
    // @ts-expect-error: Custom event of the calendar widget
    this.selectDate(event.target?.value);
    this.hideCalendar();
  }
}